import { cn } from "@/shared/lib/utils";
import logoFull from "@/assets/logo.png";
import logoIcon from "@/assets/rsly.png";
import { useSidebar } from "@/shared/components/ui/sidebar";

export function BrandLogo() {
  const { state } = useSidebar();

  return (
    <div
      className={cn(
        "flex h-12 items-center",
        state === "expanded" ? "justify-start px-3" : "justify-center",
      )}
    >
      {state === "expanded" ? (
        <img
          src={logoFull}
          alt="Researchly"
          className="block h-9 max-w-full object-contain object-left"
        />
      ) : (
        <img
          src={logoIcon}
          alt="Researchly"
          className="block h-8 max-w-full object-contain"
        />
      )}
    </div>
  );
}
